import { useEffect, useState } from 'react';
import { useHistoryState } from 'wouter/use-browser-location';

type HistoryState = {
  logout?: boolean;
};

export const useLogoutBanner = () => {
  const state = useHistoryState<HistoryState>();
  const [showBanner, setShowBanner] = useState(!!state?.logout);

  // clear logout state from history on load
  useEffect(() => {
    history.replaceState(null, '');
  }, []);

  const handleCloseBanner = () => {
    setShowBanner(false);
  };

  return {
    showBanner,
    handleCloseBanner,
  };
};
